import axios from "axios";
import config from "app/api/axiosConfig";

export default (token: string, id: string) =>
  axios.get(
    `${process.env.REACT_APP_API_HOST}/api/page?id=${id}`,
    config(token)
  );
